import { render } from "./BlogTldr.vue?vue&type=template&id=03952a41"
import script from "./BlogTldr.vue?vue&type=script&lang=js"
export * from "./BlogTldr.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3529439572/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__